import script from "./PaymentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentForm.vue?vue&type=script&setup=true&lang=js"

import "./PaymentForm.vue?vue&type=style&index=0&id=1117ce83&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1117ce83"]])

export default __exports__